import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import blog from "../../assets/images/file.png";
import BreadCrumb from "../../Components/Common/BreadCrumb.js";
import DeleteModal from "../../Components/Common/DeleteModal.js";
import EventService from "../../services/KangarooServices/EventService.js";
import { imageBaseApi } from "../../utilis/imageHelper.js";

const Event = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [filters, setFilters] = useState({ onlyActive: "" });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPage = async (currentFilters = debouncedFilters) => {
    setIsLoading(true);
    try {
      const response = await EventService.getList({ ...currentFilters });
      setData(response);
      setTotalRows(response.length);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(t);
  }, [filters]);
  useEffect(() => {
    fetchPage();
  }, [debouncedFilters]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await EventService.delete(selectedDeleteItem.id);
        fetchPage(currentPage, pageSize);
        toast.success("Event deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete Event");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  const handleStatusChange = (e) => {
    const value = e.target.value;

    setFilters((prev) => ({
      ...prev,
      onlyActive: value === "" ? "" : value === "true", // convert to boolean
    }));
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Events" pageTitle="Content Management" />
        <Row className="mb-3">
          <Col md={4}>
            <Input
              type="select"
              value={
                filters.onlyActive === "" ? "" : String(filters.onlyActive)
              }
              onChange={handleStatusChange}
            >
              <option value="">All Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Input>
          </Col>
          <Col
            md={4}
            xs={12}
            className="d-flex justify-content-start align-items-end "
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/event/create")}
            >
              + Create event
            </Button>
          </Col>
        </Row>
        {isLoading ? (
          <div className="my-3 d-flex justify-content-center align-content-center align-items-center">
            <Triangle visible height="80" width="80" />
          </div>
        ) : (
          <>
            <Row className="">
              {data?.map((item) => (
                <Col md={12} key={item.id}>
                  <Card className="shadow-sm border-0 rounded-3 page-card">
                    <Row className="g-0">
                      {/* Image */}
                      <Col lg={4}>
                        <div className="h-100 d-flex align-items-center align-content-center justify-content-center p-2 bg-light rounded-start">
                          <img
                            src={
                              item?.bannerMedia?.url
                                ? `${imageBaseApi}${item?.bannerMedia?.url}`
                                : blog
                            }
                            alt="thumb"
                            className="event-thumb-img rounded-3 img-fluid"
                            style={{
                              height: "40vh",
                              objectFit: "contain",
                              width: "100%",
                            }}
                          />
                        </div>
                      </Col>

                      {/* Content */}
                      <Col lg={8}>
                        <CardBody className="d-flex flex-column p-3">
                          {/* Slug + Status */}
                          <div className="d-flex justify-content-between mb-2">
                            {item?.slug && (
                              <small className="text-muted fw-semibold text-uppercase">
                                {item.slug}
                              </small>
                            )}
                            <Badge
                              pill
                              color={`${item?.isActive ? "success" : "danger"}`}
                            >
                              {item?.isActive?"Active":"Inactive"}
                            </Badge>
                          </div>

                          {/* Title */}
                          <h5 className="fw-bold text-dark mb-2 event-title">
                            {item.name}
                          </h5>

                          {/* Venue */}
                          {item?.venue && (
                            <p className="text-muted small mb-2">
                              <i className="ri-map-pin-line me-1"></i>
                              {item.venue}
                            </p>
                          )}

                          {/* Dates */}
                          <div className="text-muted small d-flex align-items-center mb-2">
                            <i className="ri-calendar-line me-1"></i>
                            {moment(item.startDate).format(
                              "YYYY-MM-DD hh:mm A"
                            )}
                            <span className="mx-1">—</span>
                            {moment(item.endDate).format("YYYY-MM-DD hh:mm A")}
                          </div>
                          <p className="text-muted small mb-2">
                            <i class="bx bx-calendar-event"></i>{" "}
                            {item.eventType || "Event"}
                          </p>
                          {/* Summary */}
                          <div className="content-preview text-muted small mb-3">
                            {item.description || "Event"}
                          </div>

                          {/* Bottom Section */}
                          <div className="d-flex justify-content-between align-items-center border-top pt-3">
                            <Link
                              to={`/event/${item.slug}`}
                              className="text-decoration-none link-secondary fw-semibold d-flex align-items-center"
                            >
                              View Details
                              <i className="ri-arrow-right-s-line ms-1"></i>
                            </Link>

                            <div className="d-flex gap-2">
                              <Button
                                color="btn btn-soft-warning"
                                size="sm"
                                onClick={() =>
                                  navigate(`/event/update/${item.slug}`)
                                }
                              >
                                <i className="ri-edit-line" />
                              </Button>

                              <Button
                                className="btn btn-soft-danger"
                                color="danger"
                                size="sm"
                                onClick={() => handleDeleteClick(item)}
                              >
                                <i className="ri-delete-bin-5-line" />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            <div className="d-flex justify-content-center align-content-center align-items-center">
              {totalPages > 1 && (
                <Pagination className="justify-content-center mt-4">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {[...Array(totalPages)].map((_, index) => (
                    <PaginationItem
                      key={index}
                      active={currentPage === index + 1}
                    >
                      <PaginationLink
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              )}
            </div>
          </>
        )}
      </div>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default Event;
